import * as React from "react";
import { useUpdateEffect } from "./use-update-effect";
/**
 * React hook to console-log a value when it mounts
 * and as it updates.
 *
 * @param label a label for the component
 * @param values parameters to log
 */

export function useLogger(label) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  React.useEffect(function () {
    var _console;

    (_console = console).log.apply(_console, [label + " mounted:"].concat(values));

    return function () {
      console.log(label + " unmounted");
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useUpdateEffect(function () {
    var _console2;

    (_console2 = console).log.apply(_console2, [label + " updated:"].concat(values));
  });
}